import React, {Component} from "react";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import Storage from './components/utils/Storage'
import Login from './components/Login';
import Dashboard from './components/dashboard/Dashboard';
import Grader from './components/grader/Grader'; 
import AdminPage from './components/admin/AdminPage'; 

function MainRouter() {
  return (
	<Router>
  		<Route path="/" exact render={props=> <Redirect to="/login" />} />
		<CustomRoute path="/login" component={Login} public={true} />
		<CustomRoute path="/dashboard" component={Dashboard} /> 
		<CustomRoute path="/grader/:app_id" component={Grader} public={true} />
		<CustomRoute path="/grader" exact component={Grader} public={true} />
		<AdminRoute path="/admin" component={AdminPage} public={true} />
	</Router>
  );
}


const CustomRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
	(Storage.isLoggedIn() || rest.public === true)
	? <Component {...props} />
	: <Redirect to='/login' />
  )} />

)

const AdminRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
	(Storage.isLoggedIn() && Storage.isAdmin())
	? <Component {...props} />
	: <Redirect to='/dashboard' />
  )}  />
)

export default MainRouter;


// WEBPACK FOOTER //
// ./src/Routes.js